module.exports = __webpack_public_path__ + "assets/b1efb357fdf337376b362afcbfda2f79.svg";